import * as type from '../actions/types';
import { getData } from '../models/MonthlyAvailabilities';

const initialState = {
  data: {
    allAvailableDates: [],
  },
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_MONTHLY_AVAILABILITIES_PENDING: {
      return {
        ...initialState,
        pending: true,
      };
    }

    case type.FETCH_MONTHLY_AVAILABILITIES_SUCCESS: {
      return {
        ...state,
        data: getData(action.payload.data),
        pending: false,
        success: true,
      };
    }

    case type.FETCH_MONTHLY_AVAILABILITIES_FAILURE: {
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
